import { layout } from 'src/styles/layout';
import styled from 'styled-components';
import { palette } from 'styles/colors'

// !important is needed to override main's max-width of 1440px
export const InvestorSectionWrapper = styled.div`
  max-width: 100% !important;
  background-color: ${palette.catskillWhite};
`

export const InvestorContainer = styled.div`
  max-width: 1260px !important;
  width: 100%;
  margin: 0 auto;
`

export const InvestorSection = styled.div`
  display: grid;
  column-gap: 2em;
  position: relative;
  row-gap: 4em;
  grid-template-columns: 24px 1fr 24px;
  padding: 6em 2em 4em;
  width: 100%;
  box-sizing: border-box;

  & > h1 {
    max-width: 820px;
    justify-self: center;
    grid-column: 1 / 4;
  }

  @media all and (max-width: ${layout.sm}) {
    row-gap: 2em;
    padding: 2em 2em 2em;
  }
`

export const InvestorSectionCarousel = styled.div`
  grid-column: 1 / 4;
  max-width: 100%; // prevent overflow on firefox
  justify-self: center;
  cursor: pointer;
`;

export const InvestorSectionCarouselItem = styled.div`
  height: 164px;
  width: 164px;

  div {
    display: flex;
    height: 100%;
    justify-content: center;
    align-items: center;
  }
`
